import { useEffect } from "react";
import {
	createRoutesFromChildren,
	matchRoutes,
	useLocation,
	useNavigationType,
} from "react-router";

import * as Config from "./AppConfiguration.json";
import { SATOSPortal } from "@/data-adapter/SATOSPortal";
import * as Sentry from "@sentry/react";

SATOSPortal.GetApplicationConfiguration().then((applicationConfig) => {
	const isEnabled = applicationConfig?.Features.Sentry ?? false;
	const environment = applicationConfig?.Environment;
	const isDevelopment = environment === "Development";

	Sentry.init({
		dsn: Config.SENTRY_DSN,
		release: import.meta.env.VITE_RELEASE_VERSION,
		environment,
		integrations: [
			Sentry.reactRouterV6BrowserTracingIntegration({
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			}),
			...(isEnabled ? [Sentry.replayIntegration()] : []),
			Sentry.feedbackIntegration({
				autoInject: false,
				colorScheme: "system", // Form theme can be overridden per-open via createForm({ colorScheme }) to match app light/dark
				triggerLabel: "Send feedback",
				showBranding: false,
				enableScreenshot: isDevelopment,
			}),
		],
		tracesSampleRate: isEnabled ? (applicationConfig?.SentryTracesSampleRate ?? 0.01) : 0,
		tracePropagationTargets: [/^\//, window.location.origin],
		replaysSessionSampleRate: isEnabled ? 0.1 : 0,
		replaysOnErrorSampleRate: isEnabled ? 1.0 : 0,
		beforeSend(event) {
			event.tags = {
				...event.tags,
				host: window.location.hostname,
			};

			if (event.type === "feedback") return event;
			if (isDevelopment || !isEnabled) return null;
			return event;
		},
	});
});